import { useFormField } from '@calendly/form';
import { useInputId } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import { Loader } from '@calendly/ui/components/loader';
import { Group, GroupTitle, Item } from '@calendly/ui/components/menu';
import { Control, Options, Select } from '@calendly/ui/components/select';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { SendFromEmptyOption, SendFromOption } from './send_from_option';
const senderWrapperCss = "s1s1wzc9";
const SenderWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(senderWrapperCss, props.className)} />;
});
const labelCss = "l1u3a9oh";
const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});
const loadingContainerBaseCss = "l69ltmq";
const LoadingContainerBase = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(loadingContainerBaseCss, props.className)} />;
});
const LoadingContainer = props => <LoadingContainerBase role="option" {...props} />;
const OptionsLoading = () => <LoadingContainer>
    <div role="status" aria-busy aria-label="loading">
      <Loader />
    </div>
  </LoadingContainer>;
export const SendFromField = ({
  sendOptions,
  isLoading,
  setSendWith
}) => {
  const id = useInputId();
  const [{
    value: sendWith
  }, meta, {
    setValue: setFieldValue
  }] = useFormField({
    name: 'sendWith'
  });
  const isError = meta.touched && meta.error;
  const isPhone = useDeviceType('isPhone');
  const hasGmailConnected = sendOptions?.some(email => email.type === 'gmail');
  const hasOutlookConnected = sendOptions?.some(email => email.type === 'outlook');
  useEffect(() => {
    if (sendOptions.length === 0) {
      setFieldValue(null);
      setSendWith(null);
    } else if (!sendWith || sendWith && sendOptions.length === 1 && sendOptions[0].type !== sendWith.type) {
      setFieldValue(sendOptions[0]);
      setSendWith(sendOptions[0].type);
    }
  }, [sendWith, sendOptions, setFieldValue, setSendWith]);
  const handleOptionClick = option => {
    setFieldValue(option);
    setSendWith(option.type);
  };
  return <SenderWrapper data-component="send_with_field_block">
      <Label id={id}>
        {I18n.t('publisher.send_from_calendly.field_caption.from')}
        <span aria-hidden>:</span>
      </Label>
      <Select name="sendWith" value={sendWith} onChange={handleOptionClick} invalid={isError}>
        <Control variant="minimal" aria-labelledby={id}>
          {sendWith ? <SendFromOption option={sendWith} minimized={isPhone} /> : <SendFromEmptyOption minimized={isPhone} />}
        </Control>
        <Options>
          {isLoading ? <OptionsLoading /> : <>
              {sendOptions.map(option => <Item key={option.name || option.emailAddress} onClick={() => {
            handleOptionClick(option);
          }}>
                  <SendFromOption option={option} withReconnect />
                </Item>)}
              {(!hasGmailConnected || !hasOutlookConnected) && <Group>
                  <GroupTitle>
                    {I18n.t('publisher.send_from_calendly.send_with_dropdown.title')}
                  </GroupTitle>
                  {!hasGmailConnected && <Item href="/integrations/gmail" target="_blank" rel="noreferrer" key="connect_gmail">
                      <SendFromOption option={{
                type: 'gmail',
                accessGranted: true,
                name: I18n.t('publisher.send_from_calendly.send_with_dropdown.gmail_integration')
              }} />
                    </Item>}
                  {!hasOutlookConnected && <Item href="/integrations/outlook" target="_blank" rel="noreferrer" key="connect_outlook">
                      <SendFromOption option={{
                type: 'outlook',
                accessGranted: true,
                name: I18n.t('publisher.send_from_calendly.send_with_dropdown.outlook_integration')
              }} />
                    </Item>}
                </Group>}
            </>}
        </Options>
      </Select>
    </SenderWrapper>;
};

require("./send_from_field.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./send_from_field.js");